import {  createSelector } from '@ngrx/store';
import { DesignState } from '../design.reducer';
import { selectDesign } from '../design.selector';
import { adapter } from './inverter.reducer';


const { selectAll } = adapter.getSelectors();
export namespace fromInverterSelectors {
  const inverterStateSelector = createSelector(
    selectDesign,
    (state: DesignState) => state.inverter.inverters
  );

  export const inverterSelector = createSelector(
    selectDesign,
    (state: DesignState) => state.inverter
  );

  export const allInverters = createSelector(inverterStateSelector, selectAll);
  export const selectDcAcRatio = createSelector(
    selectDesign,
    (state: DesignState) => state.inverter?.dcAcRatio
  );
  export const selectInverterEfficiency = createSelector(
    selectDesign,
    (state: DesignState) => state.inverter?.efficiency
  );

  export const selectAddedCapacity = createSelector(
    selectDesign,
    (state: DesignState) => state.inverter?.addedCapacity
  );
 
}
